<!-- Item loader is responsible for watch the editingItem chagne, and make the form-loader re-render-->
<template>
  <div id="item-editor" >
    <div class="form-loader-w">
      <form-loader v-if="editingItem !== null" :key="editingItem.id" :form-instance="editingItem"></form-loader>
    </div>
  </div>
</template>

<script>
import FormLoader from '../components/FormLoader.vue'

export default {
  name: 'ItemEditor',
  components: { FormLoader },
  computed: {
    editingItem: function () {
      return this.$store.state.editingItem
    }
  }
}
</script>

<style scoped>
#item-editor {
  background-color: #fafafa;
}
</style>
